<template>
  <div v-if="!isDisabled" class="customForm">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        @submit.prevent="
          handleSubmit(
            onSubmit.bind(
              this,
              $getConst('SUBMIT_PAYLOAD'),
              getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('SUBMIT_PAYLOAD'))
            )
          )
        "
      >
        <div v-for="(formItem, index) in message.form.formitems" :key="index" class="formGrp">
          <div class="fieldGrp">
            <label :for="`${formItem.elementData}_${index}`">{{ formItem.mainContent }}</label>
            <div v-if="formItem.inputType === $getConst('MESSAGE_TYPES.INPUT_TYPE_TEXTAREA')">
              <ValidationProvider v-slot="{ errors }" mode="eager" :rules="rules(formItem)">
                <textarea
                  :id="`${formItem.elementData}_${index}`"
                  v-model="formFields[index]"
                  :name="formItem.mainContent"
                  :disabled="isFieldsDisabled"
                  :class="`field_${formItem.elementData}`"
                  class="inputField textArea"
                  :data-element="formItem.elementData"
                  :placeholder="formItem.elementPlaceholder"
                  @keydown.enter.prevent="
                    handleSubmit(
                      onSubmit.bind(
                        this,
                        $getConst('SUBMIT_PAYLOAD'),
                        getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('SUBMIT_PAYLOAD'))
                      )
                    )
                  "
                ></textarea>
                <span
                  v-if="formItem.elementChecks && formItem.elementChecks.errorMessage && errors[0]"
                  class="formError"
                >
                  {{ formItem.elementChecks.errorMessage }}
                </span>
              </ValidationProvider>
            </div>
            <div v-else>
              <ValidationProvider v-slot="{ errors }" mode="eager" :rules="rules(formItem)">
                <input
                  :id="`${formItem.elementData}_${index}`"
                  v-model="formFields[index]"
                  :data-element="formItem.elementData"
                  :type="formItem.inputType"
                  :name="formItem.mainContent"
                  :placeholder="formItem.elementPlaceholder"
                  :disabled="isFieldsDisabled"
                  class="inputField"
                  :class="`field_${formItem.elementData}`"
                  @keydown.enter.prevent="
                    handleSubmit(
                      onSubmit.bind(
                        this,
                        $getConst('SUBMIT_PAYLOAD'),
                        getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('SUBMIT_PAYLOAD'))
                      )
                    )
                  "
                />
                <span
                  v-if="formItem.elementChecks && formItem.elementChecks.errorMessage && errors[0]"
                  class="formError"
                >
                  {{ formItem.elementChecks.errorMessage }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="formGrp submitBlk">
          <!-- Other button -->
          <div v-if="message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')]" class="secondary">
            <div v-for="(formChip, index) in message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')]" :key="index">
              <button
                v-if="
                  formChip.payload !== $getConst('CANCEL_PAYLOAD') && formChip.payload !== $getConst('SUBMIT_PAYLOAD')
                "
                :disabled="isFieldsDisabled"
                :type="formChip.payload"
                @click.prevent="handleSubmit(onSubmit.bind(this, $formChip.payload, formChip.mainContent))"
              >
                <span>{{ formChip.mainContent }}</span>
              </button>
            </div>
          </div>

          <!-- Cancel button -->
          <div>
            <button
              :disabled="isFieldsDisabled"
              class="cancel"
              @click.prevent="
                cancel(
                  $getConst('CANCEL_PAYLOAD'),
                  getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('CANCEL_PAYLOAD'))
                )
              "
            >
              {{ getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('CANCEL_PAYLOAD')) }}
            </button>
          </div>

          <!-- Submit button -->
          <div>
            <button
              :disabled="isFieldsDisabled"
              class="submit"
              @click.prevent="
                handleSubmit(
                  onSubmit.bind(
                    this,
                    $getConst('SUBMIT_PAYLOAD'),
                    getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('SUBMIT_PAYLOAD'))
                  )
                )
              "
            >
              {{ getButtonLabel(message.form[$getConst('MESSAGE_TYPES.FORM_CHIPS')], $getConst('SUBMIT_PAYLOAD')) }}
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Config
import config from '../../config'

export default {
  name: 'Form',
  props: {
    message: { type: Object, required: true },
    isDisabled: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false }
  },
  data: function() {
    return {
      isFieldsDisabled: this.isDisabled,
      formFields: []
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale'
    })
  },
  mounted: function() {
    if (!this.isDisabled) {
      this.$store.dispatch('set_input_state', false)
    }
  },
  methods: {
    rules: function(formItem) {
      const rules = {
        required: false
      }

      if (formItem.elementChecks) {
        rules.required = formItem.elementChecks.isRequired ? formItem.elementChecks.isRequired : rules.required

        if (formItem.elementChecks.regex) {
          rules.regex = new RegExp(formItem.elementChecks.regex)
        }
      }

      if (this.$getConst('VALID_VALIDATORS').indexOf(formItem.elementData) > -1) {
        rules[formItem.elementData] = true
      }

      return rules
    },
    onSubmit: function(payload, mainContent) {
      if (payload === this.$getConst('CANCEL_PAYLOAD')) {
        this.cancel(payload, mainContent)
      } else {
        const message = [
          {
            messageType: this.$getConst('MESSAGE_TYPES.FORM_MESSAGE'),
            mainContent: mainContent,
            inputType: config.INPUT_TYPES.TOUCH,
            intentAnalysed: null,
            actionDeduced: null,
            context: null
          }
        ]

        const messageInputs = []

        for (const formItem of this.message.form.formitems) {
          const input = this.$el.querySelector(`.field_${formItem.elementData}`)
          const element = input ? (input[0] ? input[0] : input.value ? input : null) : null
          if (element) {
            messageInputs.push({
              elementName: element.getAttribute('data-element'),
              elementValue: element.value
            })
          }
        }

        message[0].payload = {
          inputs: messageInputs
        }

        this.$store.dispatch('socket_userMessage', message, 'form:send').then(() => {
          this.isFieldsDisabled = true
          // Enable the input after sending the payload
          this.$store.dispatch('set_input_state', true)
        })
      }
    },

    cancel: function(payload, mainContent) {
      const message = [
        {
          messageType: this.$getConst('MESSAGE_TYPES.FORM_MESSAGE'),
          mainContent: mainContent,
          inputType: config.INPUT_TYPES.TOUCH,
          payload: payload,
          intentAnalysed: null,
          actionDeduced: null,
          context: null
        }
      ]

      this.$store.dispatch('socket_userMessage', message).then(() => {
        this.isFieldsDisabled = true
        // Enable the input after sending the payload
        this.$store.dispatch('set_input_state', true)
      })
    },

    getButtonLabel: function(chips, payload) {
      const defaultLabels = {
        [this.$getConst('CANCEL_PAYLOAD')]: this.$t('form_cancel_button'),
        [this.$getConst('SUBMIT_PAYLOAD')]: this.$t('form_submit_button')
      }

      let chip = null

      if (chips.length) {
        chip = chips.find(chip => {
          return chip.payload === payload && chip.mainContent
        })
      }

      return chip ? chip.mainContent : defaultLabels[payload]
    }
  }
}
</script>
